<template>
  <b-dropdown
    aria-role="list"
    :multiple="multiple"
    :disabled="disabled"
    :value="value"
    :class="[dropdownClass, classCss]"
    :position="position"
    @input="inputEvent"
    @active-change="activeChangeEvent"
    :append-to-body="appendToBody"
  >
    <button class="button" type="button" slot="trigger">
      <div :class="[buttonClass, { 'is-danger': required || hasError }]">
        <slot name="trigger">
          <span>{{ selectedText }}</span>
          <b-icon icon="chevron-down" />
        </slot>
      </div>
    </button>
    <slot />
  </b-dropdown>
</template>

<script>
export default {
  name: 'MovDropdown',
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number, Object, Array],
      default: () => ({})
    },
    selectedText: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    dropdownClass: {
      type: String,
      default: 'local-lm-filters'
    },
    buttonClass: {
      type: String,
      default: 'local-lm-filters--placeholder'
    },
    classCss: {
      type: String,
      default: ''
    },
    position: {
      type: String,
      default: 'is-bottom-right'
    },
    hasError: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    inputEvent (payload) {
      this.$emit('input', payload)
    },
    activeChangeEvent (payload) {
      this.$emit('active-change', payload)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/miscellaneous/MovDropdown.vue